import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './personal_v2/Header';
import Footer from './personal_v2/Footer';
import Home from './personal_v2/Home';
import Notes from './personal_v2/Notes';
import Engagements from './personal_v2/Engagements';
import Apply from './personal_v2/Apply';

export default function PersonalBrandTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#F4EEE0]" data-testid="mv-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} data-testid={`mv-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'notes' && <Notes setPage={setPage} />}
          {page === 'engagements' && <Engagements setPage={setPage} />}
          {page === 'apply' && <Apply setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
